import { useEffect, useState } from "react";
import { closeIcon } from "./svgs";
import api from "../../api/api";
import CircularProgress from "@mui/material/CircularProgress";
import ToastMessage from "../../utils/mui/righttoptoast";
import { Backdrop } from "@mui/material";
import dayjs from "dayjs";

const VisitStatusModal = ({ open,setVisitModalOpen,selectedCard, onClose,setFetchedData, current }) => {
  const [selected, setSelected] = useState(current || "");
  const [loading, setLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const practiseid = window.getPracticeId();
 const [alertmessage, setAlertMessage] = useState('');
  const [isLoading,setIsLoading]=useState(false)
  const [severity, setSeverity] = useState('success');
  const [toastopen, setOpen] = useState(false);
  const handlealert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await api.post(
        `/v1/${practiseid}/appointments/status-types`,
        {
          appointment_types: ["check-in", "visit confirmation"],
        }
      );
      if (response.status === 200) {
        setStatusOptions(response.data);
      } else {
        setStatusOptions([]);
      }
    } catch (error) {
      console.error(error);
      setStatusOptions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!open) return null;
const handleupdate=async()=>{
    try {
      setIsLoading(true)
console.log(selectedCard)
const payload={
      "appointment_id": selectedCard?.appointmentid,
   appointment_date: dayjs(selectedCard?.startDate).format("YYYY-MM-DD"),
       
    
    "visit_confirmation":String(selected)
  
}
    if(selectedCard.linked_provider){
      payload.linked_provider=selectedCard.linked_provider
    }
       const response = await api.put(`/v1/${practiseid}/checkin/patient/${selectedCard?.patientid}/update-data`,payload )
     if(response.status==200){
        setAlertMessage('Visit confirmation changed Successfully');
      setSeverity('success');
      setOpen(true);
   setFetchedData(prevData =>
  prevData.map(item =>
    item.id === selectedCard.id
      ? { ...item, visit_confirmation: selected } // update only room_no
      : item // keep others unchanged
  )
);
setTimeout(() => {
  setOpen(false)
  setVisitModalOpen(false);
}, 1200);

     }else{
        setAlertMessage(response?.message||'Something Went Wrong');
      setSeverity('info');
      setOpen(true);
     }
    } catch (error) {
      console.log(error)
        setAlertMessage('Something Went Wrong');
      setSeverity('error');
      setOpen(true);
    }finally{
setIsLoading(false)
    }
}
  // List of status values to filter
  // const allowedStatuses = [
  //   "Rescheduled",
  //   "Cancelled",
  //   "ACTIVE",
  //   "No Show",
  //   "In-Office - Confirmed",
  //   "No Update",
  //   "Tele - Confirmed",
  //   "Tele - left VM",
  //   "In-Office - left VM",
  //   "In-office - Checked In",
  //   "Awaiting Check In",
  // ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/30"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative z-10 w-[640px] max-w-[92vw] rounded-xl bg-white shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between border-b px-6 py-3">
          <span className="text-[18px] font-semibold text-[#1D2951] font-font1">
            Visit Status
          </span>
          <button onClick={onClose} className="h-4 w-4 focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:outline-none" aria-label="Close">
            {closeIcon}
          </button>
        </div>

        {/* Status buttons */}
        <div className="px-6 pt-6 pb-12 flex flex-wrap gap-3 min-h-[100px] justify-center">
          {loading ? (
            <CircularProgress />
          ) : (
            statusOptions
              // .filter((item) => allowedStatuses.includes(item.value))
              .map((item, index) => {
                const isActive = selected === item.value;
                return (
                  <button
                    key={index}
                    onClick={() => setSelected(item.value)}
                    className={
                      "px-4 py-2 rounded-full text-[14px] leading-5 font-font1 transition " +
                      (isActive
                        ? "bg-[#E88D67] text-white shadow-md shadow-[#E88D6733]"
                        : "bg-[#F9FAFB] text-[#374151] border border-[#E5E7EB]")
                    }
                  >
                    {item.value}
                  </button>
                );
              })
          )}
        </div>

        {/* Footer */}
        <div className="p-3 bg-[#F9FAFB] rounded-b-xl flex items-center justify-end gap-3">
          <button
            onClick={onClose}
            className="h-[44px] px-6 flex-1 rounded-md border border-gray-300 bg-white text-[#111827] text-sm font-medium focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:outline-none"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              handleupdate()
            }}
            className="h-[44px] px-6 flex-1 rounded-md bg-[#111827] text-white text-sm font-medium focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:outline-none"
          >
            Update
          </button>
        </div>
      </div>
       <Backdrop
              sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
              }}
              open={isLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
         <ToastMessage message={alertmessage} severity={severity} open={toastopen} handleClose={handlealert} />
    </div>
  );
};

export default VisitStatusModal;
